<script setup lang="ts">
defineOptions({
	name: 'CardSpadeIcon',
})

interface Props {
	class?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50 w-8 h-8',
})
</script>

<template>
	<svg
		:class="props.class"
		viewBox="0 0 24 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M12.0002 13.8492V15.5013"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<rect
			x="4.85938"
			y="3.44962"
			width="14.0058"
			height="18.0075"
			rx="2"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M14.5163 14.0162V14.0162C14.8275 13.7063 15.0025 13.2852 15.0025 12.846C15.0025 12.4068 14.8275 11.9858 14.5163 11.6759L12.5665 9.73214C12.2539 9.42093 11.7486 9.42093 11.436 9.73214L9.4862 11.6759C9.17497 11.9857 9 12.4068 9 12.846C9 13.2852 9.17497 13.7063 9.4862 14.0161V14.0161C10.1353 14.6624 11.1847 14.6624 11.8338 14.0161L12.0013 13.8492L12.1687 14.0162C12.8178 14.6624 13.8672 14.6624 14.5163 14.0162V14.0162Z"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M12.0002 13.8492V15.5013"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
